/**
 * The one definition of "settling-in in progress" (#2175 B4). Port of
 * mobile-management/src/features/children/settlingInProgress.ts;
 * settlingInProgress.test.ts carries the phone's fixtures.
 *
 * Open plans (one page of 100, `SETTLING_IN_PROGRESS_PARAMS`) filtered to
 * running / needs_attention by the server's `derived_status`; a row without
 * derived_status falls back to the plan's date window around today.
 */

export const SETTLING_IN_PROGRESS_PARAMS = { completed: false, pageSize: 100 } as const;

export interface PlanWindow {
  derived_status?: string | null;
  /** Optional in the web's generated DTO; the phone's type always carries it. */
  start_date?: string;
  end_date?: string | null;
}

export function inProgressSettlingIn<T extends PlanWindow>(plans: readonly T[] | undefined, today: string): T[] {
  return (plans ?? []).filter((plan) => {
    if (plan.derived_status) {
      return plan.derived_status === "running" || plan.derived_status === "needs_attention";
    }
    const start = (plan.start_date ?? "").substring(0, 10);
    const end = plan.end_date?.substring(0, 10);
    return start <= today && (!end || today <= end);
  });
}
